module.exports = __webpack_public_path__ + "img/ep-carre-festonne.e78f73a3.jpg";